const KEY = 'marginNotifications';

try {
  const raw = localStorage.getItem(KEY);
  if (raw !== null) {
    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch {
      localStorage.removeItem(KEY);
      parsed = undefined;
    }
    if (parsed !== undefined && !Array.isArray(parsed)) {
      localStorage.removeItem(KEY);
    }
  }
} catch {
  // localStorage unavailable (private mode, SSR) — nothing to sanitize
}
